import React from 'react'
import PropTypes from 'prop-types'
import ButtonPrimary from 'components/ButtonPrimary'
import useDispatch from 'modules/component/utils/hooks/useDispatch'
import pushRouterAction from 'modules/router/actions/push'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import logEventAnalyticsUtil from 'modules/analytics/utils/log-event'

const messages = defineMessages({
  checkYourForm: {
    id: 'Exercise.checkYourForm',
    defaultMessage: 'Check your form'
  }
})

export function ExerciseCheckFormButton ({ exerciseId }) {
  const dispatch = useDispatch()
  const intl = useIntl()

  const handleClick = () => {
    logEventAnalyticsUtil('CHECK_YOUR_FORM_BUTTON_CLICK', {
      exerciseId,
      source: 'EXERCISE_PAGE'
    })

    dispatch(
      pushRouterAction({
        pathname: '/tools/check-exercise-form',
        search: `?exerciseId=${exerciseId}&source=EXERCISE_PAGE`
      })
    )
  }

  return (
    <ButtonPrimary
      onClick={handleClick}
      style={{
        width: '100%',
        marginTop: '0.5rem',
        marginBottom: '0.5rem'
      }}
    >
      {formatMessageIntlUtil(intl, messages.checkYourForm)}
    </ButtonPrimary>
  )
}

ExerciseCheckFormButton.propTypes = {
  exerciseId: PropTypes.number.isRequired
}
